    import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Fade } from "react-awesome-reveal";
import h9 from '../Images/h9.jpg'
import h3 from '../Images/h3.png'
import h10 from '../Images/h10.jpg'
// --- Styled Components ---

const SectionContainer = styled.section`
  padding: 10px 0;
  width: 100%;
  overflow: hidden; // Hides the images that are outside the view
  background: #fff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const Title = styled.h2`
  padding-left: 20px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a2b49;
  text-transform: uppercase;
  margin-bottom: 30px;
  max-width: 1200px;
  margin-inline: auto;
`;

// The animation keyframe for infinite scrolling
const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); } 
`;

const CarouselTrack = styled.div`
  display: flex;
  width: calc(250px * 10); // Adjust based on image width * total images
  animation: ${scroll} 25s linear infinite; // Speed of movement

  // &:hover {
  //   animation-play-state: paused; // Stop moving when user hovers
  // }
`;

const Slide = styled.div`
  width: 500px; // Based on your image ratio
  height: 200px;
  padding: 0 15px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }
`;

// --- Mock Data ---
// We duplicate the items to ensure the loop is infinite and seamless
const partnerImages = [
h9,h3,h10
];

const fullList = [...partnerImages, ...partnerImages, ...partnerImages, ...partnerImages];

// --- Component ---

const StaffCarousel = () => {
  return (
    <SectionContainer>
      <Fade triggerOnce>
        {/* <Title>Our Foreign Technical Partner</Title> */}
      </Fade>

      <CarouselTrack>
        {fullList.map((img, index) => (
          <Slide key={index}>
            <img src={img} alt={`Partner ${index}`} />
          </Slide>
        ))}
      </CarouselTrack>
    </SectionContainer>
  );
};

export default StaffCarousel;